// @flow
import React, { PureComponent } from 'react';
import { Image, ScrollView, Share, StyleSheet, View } from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import { Text } from 'trpc-react-native-ui';

import { FullButton } from '../../components/common';
import theme from '../../theme-config';
import I18n from '../../lib/i18n';
import FormatService from '../../lib/format';
import config from '../../config';
import type { ReferralBonuses } from 'digicel-kaizen-library';
import { trackAnalyticsEvent } from '../../lib/analytics';
import { InfoDetailText } from '../../components/common/InfoDetailText';
import { formatGodchildBonuses } from '../../lib/bonuses';

export default class InviteFriend extends PureComponent<Props> {
  styles = getStyles();

  share = () => {
    if (!this.props.code || !this.props.referralBonuses?.godchild) return;
    Share.share(
      {
        message: I18n.t('Dashboard.InviteFriend.Share.message', {
          URL: `${config.APPLINK_URL}/assets/index.html#friendInvitation?code=${this.props.code}&name=${this.props.givenName}`,
          bonus: formatGodchildBonuses(this.props.referralBonuses.godchild),
          code: this.props.code,
        }),
        title: I18n.t('Dashboard.InviteFriend.Share.title'),
      },
      {
        dialogTitle: I18n.t('Dashboard.InviteFriend.Share.title'),
        subject: I18n.t('Dashboard.InviteFriend.Share.title'),
      }
    ).then(({ action }) => {
      if (action === Share.sharedAction) {
        trackAnalyticsEvent('share_friend_invitation');
      }
    });
  };

  render() {
    const styles = this.styles;
    const edgesByOs = Platform.OS === 'android' ? ['bottom', 'left', 'right'] : ['bottom', 'left', 'right']

    const { code, infoDetail, referralBonuses } = this.props;
    const { godfather, godchild, isDiscount } = referralBonuses || {};
    const sameCredit = godchild?.price && !isDiscount && godfather.price === godchild.price;
    return (
      <SafeAreaView style={styles.safeAreaView} edges={edgesByOs}>
        <View style={styles.pageContainer}>
          <ScrollView contentContainerStyle={styles.contentContainer}>
            <Image source={theme.inviteAFriend} style={styles.image} resizeMode="contain" />
            {!!referralBonuses && (
              <View>
                {sameCredit ? (
                  <View>
                    <Text style={[styles.godFatherText, styles.inviteFriendText]}>
                      {I18n.t('Dashboard.InviteFriend.text', {
                        bonus: FormatService.formatCentsToCurrency(godfather.price, true),
                      })}
                    </Text>
                    <Text style={styles.godFatherText}>
                      {I18n.t('Dashboard.InviteFriend.sameCredit', {
                        bonus: FormatService.formatCentsToCurrency(godfather.price, true),
                      })}
                    </Text>
                    <Text style={styles.referralCodeTitle} testID={'referralCodeTitle'}>
                      {I18n.t('Dashboard.InviteFriend.referralCodeText')}
                    </Text>
                    <Text style={styles.referralCodeValue} testID={'referralCodeValue'}>
                      {code}
                    </Text>
                  </View>
                ) : (
                  <View>
                    <Text style={styles.godFatherText}>
                      {I18n.t(`Dashboard.InviteFriend.${isDiscount ? 'Discount' : 'Credit'}.godfather`, {
                        bonus: FormatService.formatCentsToCurrency(godfather.price, true),
                      })}
                    </Text>
                    {!!godchild && (
                      <Text style={styles.godChildText}>
                        {I18n.t(`Dashboard.InviteFriend.${isDiscount ? 'Discount' : 'Credit'}.godchild`, {
                          bonus: formatGodchildBonuses(godchild),
                        })}
                      </Text>
                    )}
                  </View>
                )}
                {infoDetail && (
                  <InfoDetailText
                    linkText={infoDetail?.linkText}
                    linkUrl={infoDetail?.linkUrl}
                    text={infoDetail.text}
                  />
                )}
              </View>
            )}
          </ScrollView>
          <View style={styles.bottomPanel}>
            <FullButton text={I18n.t('Dashboard.InviteFriend.share')} onPress={this.share} disabled={!code} />
          </View>
        </View>
      </SafeAreaView>
    );
  }
}

type Props = StateProps;

export type StateProps = {
  code: ?string,
  givenName: string,
  infoDetail: ?{ [string]: string },
  referralBonuses: ?ReferralBonuses,
  sender: ?string,
};

const getStyles = () =>
  StyleSheet.create({
    safeAreaView: {
      flex: 1,
      backgroundColor: 'transparent',
    },
    bottomPanel: {
      borderTopColor: theme.bottomPanelBorderColor,
      borderTopWidth: 1,
      justifyContent: 'center',
      paddingHorizontal: 20,
      paddingVertical: 13,
    },
    contentContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      margin: 5,
      paddingBottom: 30,
      paddingLeft: 18,
      paddingRight: 18,
      paddingTop: 18,
    },
    godChildText: {
      color: theme.gray.normal,
      fontSize: 18,
      marginBottom: 14,
      marginHorizontal: 45,
      marginTop: 14,
      textAlign: 'center',
    },
    godFatherText: {
      fontSize: 22,
      marginHorizontal: 20,
      marginVertical: 14,
      textAlign: 'center',
    },
    inviteFriendText: {
      fontWeight: 'bold',
    },
    referralCodeTitle: {
      marginTop: 14,
      fontSize: 16,
      textAlign: 'center',
    },
    referralCodeValue: {
      fontWeight: 'bold',
      color: theme.primaryColor,
      fontSize: 38,
      textAlign: 'center',
    },
    image: {
      height: 200,
      marginBottom: 20,
    },
    pageContainer: {
      flex: 1,
      justifyContent: 'space-between',
    },
  });
